import axios from '@/request';
import qs from 'qs';

export default {
    async auth(params: any) {
        return axios.get('cos/auth', { params });
    },
    async sts(params: any) {
        return axios.get('cos/sts', { params })
    },
    async getImage(params: any) {
        return axios.get(`cos/file`, {
            params
        })
    }
}
